import React, { Component } from 'react';
import ActionCable from 'actioncable';
import * as sessionHelpers from '../../helpers/sessionHelpers'
import api from '../../utils/api'

function withWebSocketConnection(WrappedComponent, channelName) {
  return class extends Component {
    constructor(props) {
      super(props)

      if(!window.App)
        window.App = {};

      this.wrappedComponentInstance = null
    }

    componentDidMount() {
      const currentUserId = sessionHelpers.getApplicationCookie('current_user_id')
      const authToken = sessionHelpers.getApplicationCookie('authentication_token')

      const protocol = process.env.NODE_ENV === "development" ? 'ws' : 'wss';
      // TODO: refactor
      const baseUri = api.apiUrl().replace('http://', '').replace('https://', '')
      const url = `${protocol}://${baseUri}/cable?user_id=${currentUserId}&authentication_token=${authToken}&admin=true`

      if(window.App && !window.App.cable) {
        window.App.cable = ActionCable.createConsumer(url)

        window.App.cable.subscriptions.create(channelName, {
          connected: () => {},
          disconnected: () => {},
          received: (data) => {
            if (this.wrappedComponentInstance && this.wrappedComponentInstance.onDataReceived) {
              this.wrappedComponentInstance.onDataReceived(data)
            }
          }
        })
      }
    }

    proc = (wrappedComponentInstance) => {
      // NOTE: For a wrapped component to do stuff with data received via websocket,
      // the wrapped component MUST implement an instance method called onDataReceived.

      if (wrappedComponentInstance && wrappedComponentInstance.onDataReceived) {
        this.wrappedComponentInstance = wrappedComponentInstance
      } else if (wrappedComponentInstance && !wrappedComponentInstance.onDataReceived) {
        throw new Error(`"${WrappedComponent.name}" component must implement method onDataReceived`)
      }
    }

    render() {
      return <WrappedComponent {...this.props} ref={this.proc} />
    }
  }
}

export default withWebSocketConnection
